import React, { useEffect } from "react"
// import LazyLoad from "react-lazyload"
import HeroCarousel from "./Blocks/HeroCarousel/HeroCarousel"
import Hero from "./Blocks/Hero"
import TextFullWidth from "./Blocks/TextFullWidth"
import ImageText from "./Blocks/ImageText"
import LinkBlocks from "./Blocks/LinkBlocks/LinkBlocks"
import NewsCarousel from "./Blocks/NewsCarousel"
import LiveScores from "./Blocks/LiveScores"
// import Carousel from "./Blocks/Carousel/Carousel"
import HorizontalImageText from "./Blocks/HorizontalImageText"
import CtaWithBackgroundImage from "./Blocks/CtaWithBackgroundImage"
import FAQs from "./Blocks/FAQs"
import ColumnedImageWithText from "./Blocks/ColumnedImageWithText"
import NewsListing from "./Blocks/NewsListing"
// import Listing from "./Blocks/Listing/Listing"
import Partners from "./Blocks/Partners"
import Operators from "./Blocks/Operators"
import GalleryMasonry from "./Blocks/GalleryMasonry"
import Galleries from "./Blocks/Galleries"
import TheresMore from "./Blocks/TheresMore"
// import Schedule from "./Blocks/Schedule"
import Tickets from "./Blocks/Tickets"
import VideoBlock from "./Blocks/VideoBlock"
import PlayerListing from "./Blocks/PlayerListing"
import Form from "./Blocks/Form"

const FlexibleContent = (props) => {
	useEffect(() => {
		let count = 0
		const acfBlocks = props.blocks
		if (acfBlocks !== null) {
			acfBlocks.forEach((acf) => {
				// If first block is not a hero add padding so content sits beneath fixed header
				if (count === 0) {
					if (
						acf.__typename !== "WpDefaultTemplate_Acfflexiblecontent_Blocks_HeroCarousel" 
						// acf.__typename !== "WpDefaultTemplate_Acfflexiblecontent_Blocks_Hero"
					) {
						addPaddingToPage(acf.__typename === "WpDefaultTemplate_Acfflexiblecontent_Blocks_Hero")
						window.addEventListener("resize", () => addPaddingToPage(acf.__typename === "WpDefaultTemplate_Acfflexiblecontent_Blocks_Hero"))
					}
				}
				count++
			})
		}

		return () => {
			window.removeEventListener("resize", addPaddingToPage)
		}
	}, [])

	const addPaddingToPage = (attachtoheader=false) => {
		setTimeout(() => {
			const header = document.getElementsByClassName("headerWrap")[0];
			const countdown = document.getElementsByClassName("countdown")[0];
			if (header !== undefined) {
				let headerHeight = header.clientHeight
				if (window.innerWidth < 992 && countdown) headerHeight = headerHeight + countdown.clientHeight
				document.getElementsByClassName("siteWrap")[0].style.paddingTop = `${attachtoheader ? `${headerHeight}px`  : `${headerHeight + 50}px`}` // 30 = extra padding
			}
		}, 200);
	}

	const acfBlocks = props.blocks
	let blocks = ""
	// const lazyOffset = 400
	
	if (acfBlocks !== null) {
		blocks = acfBlocks.map((acf, i) => {
				// console.log(acf.__typename)

			switch (acf.__typename) {
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_HeroCarousel':
					return <HeroCarousel key={i} block={acf}  />

				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Hero':
					return <Hero key={i} block={acf} pageTitle={props.pageTitle} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_TextFullWidth':
					return <TextFullWidth key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_ImageWithText':
					return <ImageText key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_LinkBlocks':
					return <LinkBlocks key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_NewsCarousel':
					return <NewsCarousel key={i} block={acf} />
				
				// case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Carousel':
				// 	return <Carousel key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_HorizontalImageWithText':
					return <HorizontalImageText key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_CtaWithBackgroundImage':
					return <CtaWithBackgroundImage key={i} block={acf} />
			
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Faqs':
					return <FAQs key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_ColumnedImageWithText':
					return <ColumnedImageWithText key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_NewsListing':
					return <NewsListing key={i} />
				
				// case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Listing':
				// 	return <Listing key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Partners':
					return <Partners key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Operators':
					return <Operators key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_GalleryMasonry':
					return <GalleryMasonry key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Galleries':
					return <Galleries key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_TheresMore':
					return  <TheresMore key={i} block={acf} />
				
				// case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Schedule':
				// 	return <Schedule key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Tickets':
					return <Tickets key={i} block={acf} />
				
				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_VideoBlock':
					return <VideoBlock key={i} block={acf} />

				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_PlayerListing':
					return <PlayerListing key={i} />

				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_LiveScoring':
					return <LiveScores key={i} />

				case 'WpDefaultTemplate_Acfflexiblecontent_Blocks_Form':
					return <Form key={i} block={acf} />
				
				default:
					return null;
			}
		})

		return blocks
	} return null
}

export default FlexibleContent